import SecondNavbar from "./Components/SecondNavbar";
import Story from "./Components/Story";
import TwoColCampaign from "./Components/campagins/TwoColCampaign";
import HeaderCampaign from "./Components/campagins/HeaderCampaign";
import Projects from "./Components/Projects";
import MiddleCampagin from "./Components/campagins/MiddleCampagin";
import SliderShow from "./Components/SliderShow";
import ZakaCalcComponent from "./Components/ZakaCalcComponent";
import NewsTabs from "./Components/NewsTabs";
import Subscribtion from "./Components/Subscribtion";
import { FieldLabel } from "@puckeditor/core";
import "@puckeditor/core/puck.css";
import MutliSelect from "./Components/BuilderComponents/MutliSelect";
import ZakaCalcTaps from "./Components/Partials/ZakaCalcTaps";
import About from "./Components/AboutUsComponents/About";
import AboutCampagin from "./Components/AboutUsComponents/AboutCampagin";
import BePartner from "./Components/AboutUsComponents/BePartner";
import BeVolunteer from "./Components/AboutUsComponents/BeVolunteer";
import OurLocation from "./Components/AboutUsComponents/OurLocation";
import Card from "./Components/BuilderComponents/Card";
import Column from "./Components/BuilderComponents/Column";
import HeadingBlock from "./Components/BuilderComponents/HeadingBlock";
import Hero from "./Components/BuilderComponents/Hero";
import AnamZaka from "./Components/Calculators/AnamZaka";
import GoldZaka from "./Components/Calculators/GoldZaka";
import MoneyZaka from "./Components/Calculators/MoneyZaka";
import StockZaka from "./Components/Calculators/StockZaka";
import MapCampaign from "./Components/campagins/MapCampaign";
import AlbumCard from "./Components/CountryComponents/AlbumCard";
import OurProjects from "./Components/CountryComponents/OurProjects";
import RelatedProjects from "./Components/CountryComponents/RelatedProjects";
import WhatsImportant from "./Components/CountryComponents/WhatsImportant";
import CustomLayout from "./Components/Layouts/CustomLayout";
import MainLayout from "./Components/Layouts/MainLayout";
import Adresss from "./Components/OurStoryComponents/Adresss";
import AlkhairArchive from "./Components/OurStoryComponents/AlkhairArchive";
import TheStory from "./Components/OurStoryComponents/TheStory";
import AboutUs from "./Components/Pages/AboutUs";
import Blog from "./Components/Pages/Blog";
import BlogPost from "./Components/Pages/BlogPost";
import CallUs from "./Components/Pages/CallUs";
import Country from "./Components/Pages/Country";
import Events from "./Components/Pages/Events";
import Gift from "./Components/Pages/Gift";
import MediaReleases from "./Components/Pages/MediaReleases";
import MostQuestioned from "./Components/Pages/MostQuestioned";
import NewsPost from "./Components/Pages/NewsPost";
import OurOffice from "./Components/Pages/OurOffice";
import OurStory from "./Components/Pages/OurStory";
import Partner from "./Components/Pages/Partner";
import Privacy from "./Components/Pages/Privacy";
import RencetNews from "./Components/Pages/RencetNews";
import SocialMedia from "./Components/Pages/SocialMedia";
import SuccessStory from "./Components/Pages/SuccessStory";
import SuccessStoryPost from "./Components/Pages/SuccessStoryPost";
import Vision from "./Components/Pages/Vision";
import Volunteer from "./Components/Pages/Volunteer";
import WeInNumbers from "./Components/Pages/WeInNumbers";
import WhatDidTheySay from "./Components/Pages/WhatDidTheySay";
import ZacCalc from "./Components/Pages/ZacCalc";
import Breadcrumbs from "./Components/Partials/Breadcrumbs";
import CustomButtonGroup from "./Components/Partials/CustomButtonGroup";
import DonateNow from "./Components/Partials/DonateNow";
import DropDown from "./Components/Partials/DropDown";
import FixedButton from "./Components/Partials/FixedButton";
import MapCard from "./Components/Partials/MapCard";
import ProjectCard from "./Components/Partials/ProjectCard";
import RelatedSection from "./Components/Partials/RelatedSection";
import SideBar from "./Components/Partials/SideBar";
import OurPartners from "./Components/VisionComponents/OurPartners";
import VisionAndMessage from "./Components/VisionComponents/VisionAndMessage";
import OurAchivements from "./Components/WeInNumbersComponents/OurAchivements";
import WeInNumberColumns from "./Components/WeInNumbersComponents/WeInNumberColumns";

const config = {
  root: {
    render: ({ children }) => {
      return (
        <div className="puck-root">
          {children}
        </div>
      );
    },
  },
  components: {
    SecondNavbar: {
      fields: {},
      render: () => {
        return <SecondNavbar />;
      },
    },
    Story: {
      fields: {},
      render: () => {
        return <Story />;
      },
    },
    HeaderCampaign: {
      fields: {},
      render: () => {
        return <HeaderCampaign />;
      },
    },
    TwoColCampaign: {
      fields: {},
      render: () => {
        return <TwoColCampaign />;
      },
    },
    Projects: {
      fields: {
        NumberInput: {
          type: "number",
          label: "Number of projects",
          render: ({ name, onChange, value, field }) => (
            <>
              <FieldLabel label={field.label}></FieldLabel>
              <input
                defaultValue={value}
                name={name}
                onChange={(e) => {
                  const newValue = e.currentTarget.value.replace(/\D/g, "");
                  const sanitizedValue = Math.min(parseInt(newValue, 10), 12);
                  onChange(sanitizedValue);
                }}
                type="number"
                max={12}
                style={{ border: "1px solid black", padding: 4 }}
              />
            </>
          ),
        },
        Categories: {
          type: "custom",
          label: "Categories",
          render: ({ onChange }) => <MutliSelect onChange={onChange} />,
        },
      },
      render: ({ NumberInput, Categories }) => {
        return <Projects NumberInput={NumberInput} Categories={Categories} />;
      },
    },
    MiddleCampagin: {
      fields: {},
      render: () => {
        return <MiddleCampagin />;
      },
    },
    SliderShow: {
      fields: {},
      render: () => {
        return <SliderShow />;
      },
    },
    ZakaCalcComponent: {
      fields: {},
      render: () => {
        return <ZakaCalcComponent />;
      },
    },
    ZakaCalcTaps: {
      fields: {},
      render: () => {
        return <ZakaCalcTaps />;
      },
    },
    NewsTabs: {
      fields: {},
      render: () => {
        return <NewsTabs />;
      },
    },
    Subscribtion: {
      fields: {},
      render: () => {
        return <Subscribtion />;
      },
    },
    About: {
      fields: {},
      render: () => {
        return <About />;
      },
    },
    AboutCampagin: {
      fields: {},
      render: () => {
        return <AboutCampagin />;
      },
    },
    BePartner: {
      fields: {},
      render: () => {
        return <BePartner />;
      },
    },
    BeVolunteer: {
      fields: {},
      render: () => {
        return <BeVolunteer />;
      },
    },
    OurLocation: {
      fields: {},
      render: () => {
        return <OurLocation />;
      },
    },
    Card: {
      fields: {},
      render: () => {
        return <Card />;
      },
    },
    Column: {
      fields: {},
      render: () => {
        return <Column />;
      },
    },
    HeadingBlock: {
      fields: {},
      render: () => {
        return <HeadingBlock />;
      },
    },
    Hero: {
      fields: {},
      render: () => {
        return <Hero />;
      },
    },
    MutliSelect: {
      fields: {},
      render: () => {
        return <MutliSelect />;
      },
    },
    AnamZaka: {
      fields: {},
      render: () => {
        return <AnamZaka />;
      },
    },
    GoldZaka: {
      fields: {},
      render: () => {
        return <GoldZaka />;
      },
    },
    MoneyZaka: {
      fields: {},
      render: () => {
        return <MoneyZaka />;
      },
    },
    StockZaka: {
      fields: {},
      render: () => {
        return <StockZaka />;
      },
    },
    MapCampaign: {
      fields: {},
      render: () => {
        return <MapCampaign />;
      },
    },
    AlbumCard: {
      fields: {},
      render: () => {
        return <AlbumCard />;
      },
    },
    OurProjects: {
      fields: {},
      render: () => {
        return <OurProjects />;
      },
    },
    RelatedProjects: {
      fields: {},
      render: () => {
        return <RelatedProjects />;
      },
    },
    WhatsImportant: {
      fields: {},
      render: () => {
        return <WhatsImportant />;
      },
    },
    CustomLayout: {
      fields: {},
      render: () => {
        return <CustomLayout />;
      },
    },
    MainLayout: {
      fields: {},
      render: () => {
        return <MainLayout />;
      },
    },
    Adresss: {
      fields: {},
      render: () => {
        return <Adresss />;
      },
    },
    AlkhairArchive: {
      fields: {},
      render: () => {
        return <AlkhairArchive />;
      },
    },
    TheStory: {
      fields: {},
      render: () => {
        return <TheStory />;
      },
    },
    AboutUs: {
      fields: {},
      render: () => {
        return <AboutUs />;
      },
    },
    Blog: {
      fields: {},
      render: () => {
        return <Blog />;
      },
    },
    BlogPost: {
      fields: {},
      render: () => {
        return <BlogPost />;
      },
    },
    CallUs: {
      fields: {},
      render: () => {
        return <CallUs />;
      },
    },
    Country: {
      fields: {},
      render: () => {
        return <Country />;
      },
    },
    Events: {
      fields: {},
      render: () => {
        return <Events />;
      },
    },
    Gift: {
      fields: {},
      render: () => {
        return <Gift />;
      },
    },
    MediaReleases: {
      fields: {},
      render: () => {
        return <MediaReleases />;
      },
    },
    MostQuestioned: {
      fields: {},
      render: () => {
        return <MostQuestioned />;
      },
    },
    NewsPost: {
      fields: {},
      render: () => {
        return <NewsPost />;
      },
    },
    OurOffice: {
      fields: {},
      render: () => {
        return <OurOffice />;
      },
    },
    OurStory: {
      fields: {},
      render: () => {
        return <OurStory />;
      },
    },
    Partner: {
      fields: {},
      render: () => {
        return <Partner />;
      },
    },
    Privacy: {
      fields: {},
      render: () => {
        return <Privacy />;
      },
    },
    RencetNews: {
      fields: {},
      render: () => {
        return <RencetNews />;
      },
    },
    SocialMedia: {
      fields: {},
      render: () => {
        return <SocialMedia />;
      },
    },
    SuccessStory: {
      fields: {},
      render: () => {
        return <SuccessStory />;
      },
    },
    SuccessStoryPost: {
      fields: {},
      render: () => {
        return <SuccessStoryPost />;
      },
    },
    Vision: {
      fields: {},
      render: () => {
        return <Vision />;
      },
    },
    Volunteer: {
      fields: {},
      render: () => {
        return <Volunteer />;
      },
    },
    WeInNumbers: {
      fields: {},
      render: () => {
        return <WeInNumbers />;
      },
    },
    WhatDidTheySay: {
      fields: {},
      render: () => {
        return <WhatDidTheySay />;
      },
    },
    ZacCalc: {
      fields: {},
      render: () => {
        return <ZacCalc />;
      },
    },
    Breadcrumbs: {
      fields: {},
      render: () => {
        return <Breadcrumbs />;
      },
    },
    CustomButtonGroup: {
      fields: {},
      render: () => {
        return <CustomButtonGroup />;
      },
    },
    DonateNow: {
      fields: {},
      render: () => {
        return <DonateNow />;
      },
    },
    DropDown: {
      fields: {},
      render: () => {
        return <DropDown />;
      },
    },
    FixedButton: {
      fields: {},
      render: () => {
        return <FixedButton />;
      },
    },
    MapCard: {
      fields: {},
      render: () => {
        return <MapCard />;
      },
    },
    ProjectCard: {
      fields: {},
      render: () => {
        return <ProjectCard />;
      },
    },
    RelatedSection: {
      fields: {},
      render: () => {
        return <RelatedSection />;
      },
    },
    SideBar: {
      fields: {},
      render: () => {
        return <SideBar />;
      },
    },
    ZakaCalcTaps: {
      fields: {},
      render: () => {
        return <ZakaCalcTaps />;
      },
    },
    OurPartners: {
      fields: {},
      render: () => {
        return <OurPartners />;
      },
    },
    VisionAndMessage: {
      fields: {},
      render: () => {
        return <VisionAndMessage />;
      },
    },
    OurAchivements: {
      fields: {},
      render: () => {
        return <OurAchivements />;
      },
    },
    WeInNumberColumns: {
      fields: {},
      render: () => {
        return <WeInNumberColumns />;
      },
    },
  },
};

export { config };
